import { useSelector } from "react-redux"
import { secureUrl } from "../../../../../../utils/sortArray/secureUrl"
import './index.css'

const FifaCard = ({player, isLineUp = false})=>{
            const selectedTournament = useSelector(state => state?.tournaments?.selectedTournament)
            const defaultFifaCard = "https://assets.talachaapp.com/Captura%20de%20pantalla%202026-03-09%20a%20la(s)%2014.17.58-Photoroom.png"

    
    return(
                        <div  className={`card-player-plantillas ${isLineUp ? 'lineup-screen' : ''}`} >
                            <img className={`card-placeholder-talacha ${isLineUp ? 'lineup-screen' : ''} `} src={selectedTournament?.fifaCard?.img || defaultFifaCard} />
                            <img className={`card-img-profile ${isLineUp ? 'lineup-img-profile' : ''}` } src={secureUrl(player?.img)} />
                            <div style={{
                                backgroundColor: selectedTournament?.fifaCard?.color || ''
                            }}  
                            className={`card-blur-bg ${isLineUp ? 'blur-lineup' : ''}`}></div>
                            <div>
                                <p className={`${isLineUp ? 'lineup-text' : ''}`}>{player?.name}</p>
                            </div>
                        </div>

    )

}

export default FifaCard